<div class="infobox" [ngClass]="getGrayInfobox()">
  <div class="infobox-title">{{ t != null && t !== 'disable' ? (t['indicator.' + pointData?.title] || t['indicator.' + pointData?.name]) :
    ( (t !== 'disable' ? 'indicator.' : '') + (pointData?.title || pointData?.name) ) | translate }}
  </div>

  <div class="infobox-value" [ngClass]="getGrayInfoboxValue()">
    {{ getCurrent() | formatNumber: options.decimal_value }} {{ getCurrentMultiplier() }}{{ pointData?.unitOfMeasure?.trim() }}
    <span class="infobox-sub-value" *ngIf="penetration">({{ penetration.current | number : '1.2-2'}}{{ penetration.unitOfMeasure?.trim() }})</span>
  </div>

  <div class="infobox-prev-value" *ngIf="pointData && options.value_diff==null && options.hide_prev_value==null">
    Pre: {{ getPrevious() | formatNumber: options.decimal_prec_value }} {{ getPreviousMultiplier() }}<span *ngIf="options.unit_period_prec">{{options.unit_period_prec}}</span>
    <span *ngIf="options.additional_info">({{options.additional_info}})</span>

    (<span class="infobox-positive" *ngIf="(pointData.diffPercentage > 0) && options.value_diff==null" ><span
            *ngIf="options.differenzial_algebraic">∆</span> +{{ pointData.diffPercentage | number : '1.2-2'}}%</span>

    <span class="infobox-zero" *ngIf="(pointData.diffPercentage == 0) && options.value_diff==null" [ngClass]="getGrayInfoboxPreValue()"><span
            *ngIf="options.differenzial_algebraic">∆</span> +0%</span>
    <span class="infobox-negative" *ngIf="(pointData.diffPercentage < 0) && options.value_diff==null"><span
      *ngIf="options.differenzial_algebraic">∆</span> {{ pointData.diffPercentage | number : '1.2-2'}}%</span>)

  </div>
  <div class="infobox-prev-value" *ngIf="options.value_diff && options.hide_prev_value==null" [ngClass]="getGrayInfoboxPreValue()">
    Pre: {{ getPrevious() | formatNumber: options.decimal_prec_value }} {{ getPreviousMultiplier() }}<span>{{options.value_diff}}</span>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/widget/infobox/infobox.component.html